// Single source of truth for the "WotC bracket floored to 2" messaging.
//
// Bracket 1 ("Exhibition") is a social/theme construct with no mechanical
// signal, so the API can't detect it and never assigns it — a deck with no
// bracket-defining signals floors to WotC Bracket 2 and carries
// `details.brackets.wotcBracketFloored === true`. The UI marks that value with
// a `*` and an info popover. Shared by the deck-header Bracket Rating tile and
// the Brackets pane so the copy stays in lockstep.

// Heading for the ContextualHelp info popover on the `2*` marker.
export const WOTC_FLOORED_HEADING = 'Floored to Bracket 2';

// Body copy, split into paragraphs — used both for the popover and the
// Brackets pane criteria note.
export const WOTC_FLOORED_NOTE_LEAD =
    'No bracket-defining signals detected, so this is treated as Bracket 2.';
export const WOTC_FLOORED_NOTE_BODY =
    'Bracket 1 (Exhibition) is a social/theme call — art-style or ultra-casual builds carry no mechanical signal, so it can’t be detected automatically. 2 is the lowest bracket we can assign.';

// The marker appended to a floored bracket value (e.g. "2*").
export const WOTC_FLOORED_MARKER = '*';
